/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Voice_Manager_Provider_MicrosoftInputs */

const en_voice_manager_provider_microsoft = /** @type {(inputs: Voice_Manager_Provider_MicrosoftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Microsoft`)
};

const fr_voice_manager_provider_microsoft = /** @type {(inputs: Voice_Manager_Provider_MicrosoftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Microsoft`)
};

const de_voice_manager_provider_microsoft = /** @type {(inputs: Voice_Manager_Provider_MicrosoftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Microsoft`)
};

const it_voice_manager_provider_microsoft = /** @type {(inputs: Voice_Manager_Provider_MicrosoftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Microsoft`)
};

const ru_voice_manager_provider_microsoft = /** @type {(inputs: Voice_Manager_Provider_MicrosoftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Microsoft`)
};

const es_voice_manager_provider_microsoft = /** @type {(inputs: Voice_Manager_Provider_MicrosoftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Microsoft`)
};

const zh_cn2_voice_manager_provider_microsoft = /** @type {(inputs: Voice_Manager_Provider_MicrosoftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`微软`)
};

const ja_voice_manager_provider_microsoft = /** @type {(inputs: Voice_Manager_Provider_MicrosoftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`マイクロソフト`)
};

const hi_voice_manager_provider_microsoft = /** @type {(inputs: Voice_Manager_Provider_MicrosoftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`माइक्रोसॉफ्ट`)
};

const pt_pt2_voice_manager_provider_microsoft = /** @type {(inputs: Voice_Manager_Provider_MicrosoftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Microsoft`)
};

/**
* | output |
* | --- |
* | "Microsoft" |
*
* @param {Voice_Manager_Provider_MicrosoftInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const voice_manager_provider_microsoft = /** @type {((inputs?: Voice_Manager_Provider_MicrosoftInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Voice_Manager_Provider_MicrosoftInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_voice_manager_provider_microsoft(inputs)
	if (locale === "de") return de_voice_manager_provider_microsoft(inputs)
	if (locale === "it") return it_voice_manager_provider_microsoft(inputs)
	if (locale === "ru") return ru_voice_manager_provider_microsoft(inputs)
	if (locale === "es") return es_voice_manager_provider_microsoft(inputs)
	if (locale === "zh-CN") return zh_cn2_voice_manager_provider_microsoft(inputs)
	if (locale === "ja") return ja_voice_manager_provider_microsoft(inputs)
	if (locale === "hi") return hi_voice_manager_provider_microsoft(inputs)
	if (locale === "pt-PT") return pt_pt2_voice_manager_provider_microsoft(inputs)
	return en_voice_manager_provider_microsoft(inputs)
});